import { FaIdCard } from "react-icons/fa";

import { MdDelete } from "react-icons/md";

import Search from "../../Search/Search";
import Title from "../../Title/Title";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import { Tooltip } from "react-tooltip";
import Add from "../../Buttons/Add";
import { useDelete, useFetch, useFilter } from "../../../ApiS";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import Table, { TableOperation } from "../../Table";
import { RiEditBoxFill } from "react-icons/ri";
import { FaEye, FaRegTrashAlt } from "react-icons/fa";
import { usePopUpsStore } from "../../../store/PopUpStore";
import PopUpDelete from "../../PopUps/PopUpDelete (1)";
import Pagination from "../../pagination/Pagination (1)";
import { useEffect } from "react";
import Loader from "../../Loader";

interface Employee {
  id: string | number;
  first_name: string;

  last_name: string;

  father_name: string;

  mother_name: string;

  national_id: string;
  place_of_registration: string;
}

interface EmployeesData {
  data: { data: Employee[]; last_page: number };
}

const Accounts_Emp: React.FC = () => {
  const { setPopUpDelete, popUpDelete } = usePopUpsStore();
  const { searchParams, handleParamsClick, handleParamDelete } = useFilter();

  const operations: TableOperation[] = [
   
    {
      name: "edit",
      icon: RiEditBoxFill,
      link: true,
      onClick: () => {
        console.log("edit");
      },
    },
    {
      name: "delete",
      icon: FaRegTrashAlt,
      link: true,
      onClick: (id) => {
        setPopUpDelete([id, true]);
      },
    },
  ];
  const { id } = useParams();

  const page = searchParams.get("page") || 1; 
  const search = searchParams.get("search") || ""; 
  
  const { data , isLoading } = useFetch(
    `admin/employees?page=${page}&search=${search}`,
    `admin/employees?page=${page}&search=${search}`
  );
  

  const { mutation, deleteItem } = useDelete(
    () => window.location.reload(),
    () => console.log(mutation.error)
  );
  console.log(data);
  return (
    <>
      <Row>
        <Col>
          <Title title="حسابات الموظفين" />
        </Col>
      </Row>

      <Row>
        <Col lg={11} className="flex justify-center">
          <Search
            placeholder="  اسم الموظف / رقمه "
            className="!w-[80%] border-2 border-[#efc5e6]"
          />
        </Col>
      </Row>

      {/* <table className="w-full bg-slate-100  max-lg:w-[850px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
            <thead className=" text-black bg-[#efc5e6] h-[70px] font-bold text-base border border-white">
              <tr>
                <td> اسم الموظف ونسبته</td>
                <td> الاب </td>
                <td> الام </td>
                <td> الايميل </td>
                <td> رقمه</td>
                <td>العمليات</td>
              </tr>
            </thead>

            <tbody className="h-[70px]">
              {data?.data?.data.map((e, id) => (
                <>
                  <tr key={id} className="border-2 border-white">
                    <td>
                      {e.first_name}
                      {e.last_name}
                    </td>
                    <td>{e.father_name}</td>
                    <td>{e.mother_name}</td>
                    <td>{e.place_of_registration}</td>
                    <td>{e.id}</td>
                    <td>
                      <div className="flex justify-evenly">
                        <Link to={`/ٌregesteredemployees/${e.id}`}>
                          <div
                            id={`info-emp-${id}`}
                            className="flex justify-center cursor-pointer"
                          >
                            <FaIdCard size={30} className="text-[#c433a4]" />
                            <Tooltip
                              anchorSelect={`#info-emp-${id}`}
                              style={{ background: "#475569" }}
                            >
                              <button> معلومات الموظف </button>
                            </Tooltip>
                          </div>
                        </Link>

                        <div
                          id={`delete-emp-${id}`}
                          className="flex justify-center cursor-pointer"
                        >
                          <MdDelete
                            onClick={() => {
                              setSure(true);
                            }}
                            size={30}
                            className="text-red-700"
                          />
                          <Tooltip
                            anchorSelect={`#delete-emp-${id}`}
                            style={{ background: "#475569" }}
                          >
                            <button> حذف الموظف </button>
                          </Tooltip>
                          {sure && (
                            <>
                              <ToastContainer />
                              {mutation.isLoading ? <Loader /> : ""}
                              <div
                                className="fixed top-0 left-0  h-[105px]   !z-50"
                                onClick={() => setSure(false)}
                              ></div>
                              <div
                                className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 border-2 border-Third   rounded-3xl !z-50 flex justify-center items-center max-sm:w-full`}
                              >
                                <div className="bg-slate-50 !z-50 rounded-3xl w-[400px] max-w-[500px] min-h-[200px]">
                                  <p className="font-semibold text-xl text-center py-7">
                                    هل أنت متأكد من حزف الموظف {e.first_name}{" "}
                                    {e.id}
                                  </p>
                                  <div className="flex items-center justify-center gap-3 m-5">
                                    <ButtonRed
                                      className="py-3 !px-"
                                      onClick={() => {
                                        deleteItem(`admin/employees/${id}`);
                                        setSure(false);
                                      }}
                                      name="نعم"
                                    />
                                    <ButtonRed
                                      className="mx-2  !px-2  font-semibold border-2 border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white rounded-xl ml-5"
                                      onClick={() => setSure(false)}
                                      name=" إلغاء"
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                </>
              ))}
            </tbody>
          </table> */}

  {isLoading && <Loader/>}
      <Row justify="center"> 
      
          <Table<Employee>
            tableHeads={[
              "اسم الموظف ",
              " الكنية",
              " رقم الموظف",
            
              " الرقم الوطني",
              "مكان التسجيل",
              " العمليات",
            ]}
            tableBody={data?.data?.data}
            keys={[
              "first_name",
              "last_name",
              "id",
          
              "national_id",
              "place_of_registration",
            ]}
            operations={operations}
            className="lg:min-w-[100px] md:min-w-[50px]"
            />
          {data?.data?.data?.length > 0 &&  <Pagination pageCount={data?.data?.last_page} /> }
          
          <PopUpDelete
            text="هل أنت متأكد من حذف هذا الموظف؟"
            onClickDelete={() =>
              deleteItem(`admin/employees/${popUpDelete[0]}`)
            }
          />
        
      </Row>

      <Add link={"/regesteredemployees/add"} />
    </>
  );
};

export default Accounts_Emp;
